<template>
  <section v-home-reveal class="audience" :aria-label="t('whoIsThisAppFor')">
    <div class="copy">
      <p class="kicker">{{ t('discoverColorText') }}</p>
      <h2>{{ t('whoIsThisAppFor') }}</h2>
    </div>
    <ul class="home-stagger">
      <li v-for="item in audience" :key="item.titleKey">
        <p>{{ t(item.titleKey) }}</p>
      </li>
    </ul>
  </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { HOME_AUDIENCE } from './home.data';
import { vHomeReveal } from './home-reveal';

export default defineComponent({
  directives: {
    homeReveal: vHomeReveal,
  },
  setup() {
    const { t } = useI18n();

    return {
      t,
      audience: HOME_AUDIENCE,
    };
  },
});
</script>
<style scoped lang="scss">
.audience {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.15fr);
  gap: clamp(20px, 4vw, 48px);
  align-items: center;
  margin: 0 0 64px;
  text-align: left;
}

.copy {
  min-width: 0;
}

.kicker {
  display: inline-flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0 0 14px;
  font-size: 11px;
  letter-spacing: 0.22em;
  line-height: 1.45;
  text-transform: uppercase;
  color: rgba(246, 243, 238, 0.62);
}

.kicker::before {
  content: '';
  flex-shrink: 0;
  width: 28px;
  height: 2px;
  margin-top: 0.55em;
  border-radius: 999px;
  background: linear-gradient(90deg, #fa496e, #a67eff, #52dbff);
}

h2 {
  margin: 0;
  max-width: 12ch;
  font-size: clamp(1.7rem, 3.6vw, 2.7rem);
  font-weight: 600;
  letter-spacing: -0.045em;
  line-height: 1.05;
}

ul {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: audience;
}

li {
  position: relative;
  min-height: 100%;
  padding: 22px 18px 20px 20px;
  overflow: hidden;
  border: 1px solid rgba(246, 243, 238, 0.14);
  border-radius: 22px;
  background: rgba(20, 16, 24, 0.42);
  backdrop-filter: blur(14px);
  counter-increment: audience;
  transition: transform 0.4s ease, border-color 0.4s ease, box-shadow 0.4s ease;
}

li::before {
  display: block;
  margin-bottom: 12px;
  font-size: 12px;
  letter-spacing: 0.16em;
  color: var(--accent, #a67eff);
  content: counter(audience, decimal-leading-zero);
}

li::after {
  content: '';
  position: absolute;
  left: 0;
  top: 16px;
  bottom: 16px;
  width: 2px;
  background: var(--accent, #a67eff);
}

li:nth-child(1) {
  --accent: #fa496e;
}

li:nth-child(2) {
  --accent: #a67eff;
}

li:nth-child(3) {
  --accent: #52dbff;
}

li:hover {
  transform: translateY(-6px);
  border-color: rgba(246, 243, 238, 0.28);
  box-shadow: 0 18px 36px rgba(8, 6, 12, 0.28);
}

p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(246, 243, 238, 0.82);
}

@media (max-width: 900px) {
  .audience {
    grid-template-columns: 1fr;
    margin-bottom: 48px;
  }

  .copy {
    max-width: none;
  }

  h2 {
    max-width: none;
  }

  ul {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  li {
    transition: none;
  }

  li:hover {
    transform: none;
  }
}
</style>
